import React, { useState } from "react";

type ButtonInputToggleType = {
  label: string;
  onToggle: (isToggled: boolean) => void;
  inputPlaceholder: string;
  isRecommended?: boolean;
};

export const ButtonInputToggle: React.FC<ButtonInputToggleType> = ({
  label,
  onToggle,
  inputPlaceholder,
  isRecommended = false,
}) => {
  const [isToggled, setIsToggled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const handleToggle = () => {
    const newToggledState = !isToggled;
    setIsToggled(newToggledState);
    onToggle(newToggledState);
  };

  const handleToggleBack = () => {
    handleToggle();
    setIsToggled(false);
    setSubmitted(false);
  };

  const validateInput = (value: string) => {
    // This regex allows only letters, numbers, and spaces
    return value.replace(/[^a-zA-Z0-9 ]/g, "");
  };

  return (
    <>
      {!isToggled && !submitted && (
        <button
          onClick={handleToggle}
          className="w-full leading-none !h-[40px] !rounded border border-white/20 hover:bg-[#828282]/20  text-[#C4C4C4] font-medium"
        >
          or create new {label}
        </button>
      )}

      {isToggled && !submitted && (
        <div className="flex items-center gap-x-2">
          <div className="h-[38px] flex border border-white/20 rounded-[4px] flex-1">
            <input
              className="w-full px-3 leading-none text-white border-none outline-none bg-white/10"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(validateInput(e.target.value))}
              placeholder={inputPlaceholder}
            />

            <button
              className="px-6 text-white bg-white/20"
              onClick={() => {
                if (inputValue.length > 0) {
                  setSubmitted(!submitted);
                }
              }}
            >
              Create
            </button>
          </div>
          <button className="px-5" onClick={() => handleToggleBack()}>
            Cancel
          </button>
        </div>
      )}
      {submitted && (
        <div className="flex flex-1 gap-x-2">
          <div
            className={`${
              isRecommended
                ? "bg-[rgba(144,97,218,0.20);] border border-[#9061DA]"
                : "bg-[#854ECA]/50"
            }   text-white flex px-3 items-center h-[38px] flex-1 gap-x-3 leading-none rounded`}
          >
            <img src="/images/fub-grey.png" alt="fub" />
            <span className="flex-1">{inputValue}</span>
            {isRecommended && (
              <span className="text-[#AB7AE0] text-[8px] font-medium leading-none">
                Recommended
              </span>
            )}
          </div>
          <button
            onClick={() => handleToggleBack()}
            className="flex flex-1 max-w-[198px] items-center justify-center h-[38px] border border-white/10 bg-[#828282]/10 rounded px-5 leading-none text-white cursor-pointer hover:bg-[#828282]/20"
          >
            or select existing {label}
          </button>
        </div>
      )}
    </>
  );
};
